import ProductTypeTrigger from './parts/product-type-trigger'
import ProductsTrigger from './parts/products-trigger'
import React, { ReactElement, useEffect, useState } from 'react'
import {
  FormControl,
  FormControlLabel,
  FormLabel,
  Paper,
  Radio,
  RadioGroup,
} from '@mui/material'
import { PromotionType } from '@types'
import { makeStyles } from 'tss-react/mui'

type PropsType = {
  className: string | null
  promotion: PromotionType | null
  editing: boolean
  onConfigurationChange: (object) => void
}

type ConfigurationType = {
  triggering_product_ids: number[]
  triggering_product_type: string | null
}

const useStyles = makeStyles()((theme) => ({
  paperWrapper: {
    padding: theme.spacing(2),
  },
  paperMargin: {
    marginTop: theme.spacing(2),
  },
}))

const FreeTriggeredSmallCup = ({
  className,
  promotion,
  editing,
  onConfigurationChange,
}: PropsType): ReactElement => {
  const { classes } = useStyles()
  const [trigger, setTrigger] = useState('products')
  const [productType, setProductType] = useState('')
  const [productIds, setProductIds] = useState<number[]>([])
  const currentConfig = promotion ? promotion.configuration : {}
  const config: ConfigurationType = {
    triggering_product_ids: [],
    triggering_product_type: null,
    ...currentConfig,
  }

  const resetConfiguration = () => {
    setProductType('')
    setProductIds([])
  }

  useEffect(() => {
    resetConfiguration()
  }, [])

  useEffect(() => {
    if (!promotion) return
    if (config.triggering_product_type) {
      setTrigger('type')
      setProductType(config.triggering_product_type)
    } else {
      setProductIds(config.triggering_product_ids)
    }
  }, [promotion])

  useEffect(() => {
    prepareConfiguration()
  }, [productType, productIds])

  const handleTriggerTypeChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    resetConfiguration()
    setTrigger(e.target.value)
  }

  const prepareConfiguration = () => {
    const newConfig: any = {}
    if (trigger == 'type') {
      newConfig.triggering_product_type = productType
    } else {
      newConfig.triggering_product_ids = productIds
    }
    onConfigurationChange(newConfig)
  }

  return (
    <div className={className || ''}>
      <Paper className={classes.paperWrapper}>
        <div>
          <FormControl component='fieldset'>
            <FormLabel component='legend'>Promotion Is Triggered By</FormLabel>
            <RadioGroup
              aria-label='type'
              name='type'
              onChange={handleTriggerTypeChange}
              value={trigger}
            >
              <FormControlLabel
                control={<Radio />}
                disabled={!editing}
                label='Trigger By Products'
                value='products'
              />
              <FormControlLabel
                control={<Radio />}
                disabled={!editing}
                label='Trigger By Product Type'
                value='type'
              />
            </RadioGroup>
          </FormControl>
        </div>
      </Paper>

      <div className={classes.paperMargin}>
        {trigger == 'products' && (
          <ProductsTrigger
            editing={editing}
            onChangeProductIds={setProductIds}
            productIds={productIds}
          />
        )}

        {trigger == 'type' && (
          <ProductTypeTrigger
            editing={editing}
            onProductTypeChange={setProductType}
            productType={productType}
          />
        )}
      </div>
    </div>
  )
}

export default FreeTriggeredSmallCup
